import type {Modal} from '../../types'

const initialState: Monitoring = {
  modalError: '',
  modalLoader: false,
  isPortfolioCreated: false,
  isPortfolioDeleted: false,
  isTranslationUpdated: false,
}

export default (state: Modal = initialState, action): Modal => {
  const {type, payload} = action
  switch (type) {
    case 'CREATE_PORTFOLIO':
      return {
        ...state,
        modalLoader: true,
        isPortfolioCreated: false,
      }
    case 'CREATE_PORTFOLIO_SUCCESS':
      return {
        ...state,
        modalLoader: false,
        modalError: '',
        isPortfolioCreated: true,
      }
    case 'CREATE_PORTFOLIO_FAILURE':
      return {
        ...state,
        modalLoader: false,
        modalError: payload.data.message || 'Service is unavailable, please try again later.',
      }
    case 'DELETE_PORTFOLIO':
      return {
        ...state,
        modalLoader: true,
        isPortfolioDeleted: false,
      }
    case 'DELETE_PORTFOLIO_SUCCESS':
      return {
        ...state,
        modalLoader: false,
        modalError: '',
        isPortfolioDeleted: true,
      }
    case 'DELETE_PORTFOLIO_FAILURE':
      return {
        ...state,
        modalLoader: false,
        modalError: payload.data.message || 'Service is unavailable, please try again later.',
      }
    case 'RESET_MODAL_ERROR':
      return {
        ...state,
        modalError: '',
      }
    case 'UPDATE_TRANSLATIONS':
      return {
        ...state,
        modalLoader: true,
        isTranslationUpdated: false,
        modalError: '',
      }
    case 'UPDATE_TRANSLATIONS_SUCCESS':
      return {
        ...state,
        modalLoader: false,
        isTranslationUpdated: true,
        modalError: '',
      }
    case 'UPDATE_TRANSLATIONS_FAILURE':
      return {
        ...state,
        modalLoader: false,
        modalError: payload.data.message || 'Service is unavailable, please try again later.',
      }
    case 'LOG_OUT':
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/modal/reducer.js